// extracted by mini-css-extract-plugin
export default {"distributedInput":"distributedInput_distributedInput__7ve9O"};